namespace $.$$ {

	$mol_style_define( $shm_ba_summary_card, {
		display: 'grid',
		gap: '6px',
		border: {
			width: '1px',
			style: 'solid',
			color: $mol_theme.line,
			radius: '8px',
		},
		padding: '12px',
		cursor: 'pointer',

		'@': {
			shm_ba_summary_card_selected: {
				true: {
					border: {
						color: $mol_theme.current,
					},
				},
			},
		},

		Title: {
			justifyContent: 'flex-end',
			textAlign: 'right',
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
		},

		Value: {
			justifyContent: 'flex-end',
			textAlign: 'right',
			font: {
				size: '24px',
				weight: 'bold',
			},
		},
	} )

}
